<template>
    <div class="eval-and-award">
        <div class="evaluation">
            <div class="star">
                <img src="@/assets/img/shareHouse/star_orange.svg" alt="">
                {{rateAverage.toFixed(1)}}
            </div>
            <div class="eval-count">
                ({{rateCommentTotal}}評價)
            </div>
        </div>
        <div class="address h-align">
            <img src="@/assets/img/shareHouse/marker_blue.svg" alt="">
            {{address}} 
        </div>
        <!-- <div class="award">
            <img src="@/assets/img/shareHouse/award_orange.svg" alt="">
            優質房東
        </div> -->
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters({
            address: 'GET_SHARE_HOUSE_ADDRESS',
            rateAverage: 'GET_SHARE_HOUSE_RATE_AVERAGE',
            rateCommentTotal: 'GET_SHARE_HOUSE_RATE_COMMENT_TOTAL',
        })
    },
}
</script>
<style lang="scss" scoped>
    .eval-and-award{
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;
        .evaluation{
            display: flex;
            align-items: center;
            margin-right: 16px;
            .star{
                display: flex;
                align-items: center;
                color: #ff9275;
                margin-right: 4px;
                img{
                    margin-right: 6px;
                }
            }
            .eval-count{
                color: #909090;
            }
        }
        .award{
            display: flex;
            align-items: center;
            color: #909090;
            img{
                margin-right: 6px;
            }
        }
        .address{
            color: #2db2ff;
            font-size: 16px;
            >img{
                margin-right: 6px;
            }
        }
    }
    @media (max-width: 992px) {
        .eval-and-award{
            display: none;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/shareHouse/evaluationAndAward.vue